import React, { FunctionComponent, SVGProps } from "react";

import { ReactComponent as NotificationUploadIcon } from "assets/icons/notification-upload.svg";
import { ReactComponent as NotificationCommentIcon } from "assets/icons/notification-comment.svg";
import { ReactComponent as NotificationAnswerIcon } from "assets/icons/notification-answer.svg";
import { NotificationAction } from "store/types";

const NotificationIconsHash: Partial<
  Record<NotificationAction, FunctionComponent<SVGProps<SVGSVGElement> & { title?: string | undefined }>>
> = {
  file: NotificationUploadIcon,
  comment: NotificationCommentIcon,
  reply: NotificationCommentIcon,
  answer: NotificationAnswerIcon
};
interface Props {
  type: NotificationAction;
  className?: string;
}

export const NotificationIcon: React.FC<Props> = ({ type, ...props }) => {
  const NotificationIcon = NotificationIconsHash[type];

  return NotificationIcon ? (
    <NotificationIcon style={{ flexShrink: 0 }} {...props} />
  ) : (
    <NotificationUploadIcon style={{ flexShrink: 0 }} {...props} />
  );
};
